import React from "react";
import { withRouter } from "react-router";
import Header from "../../../_legacy/Containers/Guest/Header.js";
import Footer from "../../../_legacy/Containers/Guest/Footer.js";

/*
 * Where Stripe returns the patient after they pay a booking deposit link. The
 * booking is confirmed by the webhook, not by landing here, so this only tells
 * the patient they are finished — it must not send them into online booking.
 */
const AppointmentPaymentSuccess = () => {
  return (
    <div className="guest">
      <Header />
      <div className="wrapper">
        <div className="card-block">
          <div className="login-main m-t-60">
            <h1>You&apos;re all done here</h1>
            <h4 className="m-b-40">
              Your payment went through and your appointment is confirmed. You
              can close this page.
            </h4>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(AppointmentPaymentSuccess);
